import React from 'react';
import './App.css';
import Map from './components/Map';

function App() {
  React.useEffect(() => {
    document.title = 'VTS Area';
  }, []);

  return (
    <div className="App">
      <div style={{ width: '100vw', height: '100vh' }}>
        <Map />
      </div>
    </div>
  );
}

export default App;
